module.exports = {
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Dropdownitem');
			} else {
				cannot('manage', 'Dropdownitem');
				can('read', 'Dropdownitem');
			}
		});

		return { ability };
	}
};
